// extracted by mini-css-extract-plugin
export default {"button":"NYhmKnK8"};